import React from 'react'
import {
  Text,
  Link,
  Stack,
  HStack,
  VStack,
  Heading,
  Accordion,
  AccordionItem,
  AccordionIcon,
  AccordionPanel,
  AccordionButton
} from '@chakra-ui/react'

import { RecommendationIcon } from '.'
import { renderAnswerValue, getRecommendation } from '../utils'

export const ReportRecommendations = ({ loading, report, ...props }) => {
  const answers = report?.dimensionScores
    .slice()
    .sort((a, b) => a.dimension.scale - b.dimension.scale)
    .map(({ dimension, score }, index) => ({
      score,
      dimension,
      answers: report?.answers.filter(answer => answer.question.dimension.id === dimension.id)
    }))

  return (
    <Accordion allowMultiple defaultIndex={[0, 1, 2, 3, 4]}>
      {answers?.map(({ dimension: { id, name }, score, answers }, index) => (
        <AccordionItem key={index}>
          <AccordionButton py={5} bg='gray.200'>
            <Heading flex={1} size='md' textAlign='left'>
              {name}
            </Heading>
            <HStack>
              <Text>Score:</Text>
              <Text width='30px' textAlign='left'>
                {(score * 100).toFixed(0)}
              </Text>
            </HStack>
            <AccordionIcon ml={4} />
          </AccordionButton>
          <AccordionPanel px={0}>
            <Accordion allowMultiple>
              {answers.map((answer, index) => {
                const recommendation = getRecommendation(answer)
                return (
                  <AccordionItem key={index} borderWidth={1} my={3}>
                    <AccordionButton>
                      <Stack flex={1} direction={{ base: 'column', md: 'row' }} align='center'>
                        <VStack flex={1} p={2} align='stretch'>
                          <Text textAlign='left'>
                            <Text as='span' fontWeight='bold' display='inline' mr={1}>
                              Pergunta:
                            </Text>
                            {answer.question.text}
                          </Text>
                          <Text textAlign='left'>
                            <Text as='span' fontWeight='bold' display='inline' mr={1}>
                              Recomendação:
                            </Text>
                            {recommendation.text}
                          </Text>
                          {answer?.question?.associatedLink && (
                            <Text textAlign='left'>
                              <Text as='span' fontWeight='bold' display='inline' mr={1}>
                                Sugestão de Leitura:
                              </Text>
                              {answer?.question.associatedLink &&
                              answer?.question.associatedLink.startsWith('http') ? (
                                <Link
                                  isExternal
                                  color='teal.500'
                                  href={answer.question.associatedLink}>
                                  Link
                                </Link>
                              ) : (
                                <Text display='inline'>{answer.question.associatedLink}</Text>
                              )}
                            </Text>
                          )}
                        </VStack>
                        {recommendation.score !== null && (
                          <RecommendationIcon
                            text={recommendation.text}
                            score={recommendation.score}
                          />
                        )}
                      </Stack>
                      <AccordionIcon ml={4} />
                    </AccordionButton>
                    <AccordionPanel p={3} borderTopWidth={1}>
                      <HStack p={2} align='stretch'>
                        <Text>
                          <Text as='span' fontWeight='bold' display='inline' mr={1}>
                            Resposta:
                          </Text>{' '}
                          {renderAnswerValue(answer)}
                        </Text>
                      </HStack>
                    </AccordionPanel>
                  </AccordionItem>
                )
              })}
            </Accordion>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  )
}

export default ReportRecommendations
